import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import SideMenu from '../navigation/SideMenu';
import clsx from 'clsx';

import TopBar from './TopBar';
import { useMenu } from '@src/providers/MenuProvider';

interface LayoutProps {
  children: any;
  className?: string;
}

const Layout: FunctionComponent<LayoutProps> = ({ children, className }) => {
  const { menuWidth, setIsMenuOpen } = useMenu();

  const handleToggleMenu = () => {
    setIsMenuOpen(menuWidth === 0);
  };

  return (
    <Box sx={{ display: 'flex' }} className={clsx(className)}>
      <SideMenu />
      <Box sx={{ marginLeft: menuWidth !== 0 ? '0px' : `-${menuWidth}px` }}>
        <TopBar toggleMenu={handleToggleMenu} />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            margin: theme.spacing(1),
            boxSizing: 'border-box',
            height: `calc(100vh - ${theme.spacing(10)})`,
          })}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
